import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import style from './multi-package-badge.module.less';

const MultiPackageBadge = ({ packageCount = 0, isExpanded = false }) => {
  return (
    <div
      className={classnames(style['multi-package-count'], {
        [style.expanded]: isExpanded,
      })}
    >
      <span className={style['multi-package-badge']}>{packageCount}</span>
      <FormattedMessage defaultMessage='Packages' description='multiPackage.packages' id='majlxZ' />
    </div>
  );
};

MultiPackageBadge.propTypes = {
  packageCount: PropTypes.number,
  isExpanded: PropTypes.bool,
};

export default MultiPackageBadge;
